import React from "react";
import { Size } from "./MarkerSize";
import { MarkerSize } from "./NotificationMarker";
import { useAppSelector } from "../../../../../app/hooks";
import { selectIsNotification } from "../../../../../features/notifications/notificationSlice";
import { GroupImage } from "./GroupImageSelect";
import { IoIosNotifications } from "react-icons/io";

const greenDotSvg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
  <circle cx="12" cy="12" r="10" fill="green"/>
</svg>`;

const redDotSvg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
  <circle cx="12" cy="12" r="10" fill="red"/>
</svg>`;

const yellowDotSvg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
  <circle cx="12" cy="12" r="10" fill="yellow"/>
</svg>`;

const imageNotFoundSvg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
  <rect x="2" y="2" width="20" height="20" fill="none" stroke="gray" stroke-width="2"/>
  <line x1="2" y1="2" x2="22" y2="22" stroke="gray" stroke-width="2"/>
  <line x1="2" y1="22" x2="22" y2="2" stroke="gray" stroke-width="2"/>
</svg>`;

export const greenDotURL = `data:image/svg+xml;base64,${btoa(greenDotSvg)}`;
export const redDotURL = `data:image/svg+xml;base64,${btoa(redDotSvg)}`;
export const yellowDotURL = `data:image/svg+xml;base64,${btoa(yellowDotSvg)}`;

export const defaultActiveImage: GroupImage = {
  image_id: "",
  content_type: "SVG",
  description: "Default active image",
  url: greenDotURL,
};
export const defaultInactiveImage: GroupImage = {
  image_id: "",
  content_type: "SVG",
  description: "Default inactive image",
  url: redDotURL,
};
export const defaultActiveAcknowledgedImage: GroupImage = {
  image_id: "",
  content_type: "SVG",
  description: "Default inactive image",
  url: yellowDotURL,
};
export const imageNotFoundURL = `data:image/svg+xml;base64,${btoa(imageNotFoundSvg)}`;

export const StatusMarkerButtonIcon = (
  <IoIosNotifications
    size={40}
    className="bg-white opacity-0 group-hover:opacity-70 absolute -ml-[6px] -mt-5 h-16 w-[calc(100%+12px)]"
  />
);

export const getMarkerSize = (markerSize: Size, screenWidth: number): MarkerSize => {
  const sizeMap = {
    small: 0.03,
    medium: 0.06,
    large: 0.1,
  };
  const percent = sizeMap[markerSize];
  const size = Math.round(screenWidth * percent);
  return [size, size];
};
